import React from 'react';
import PropTypes from 'prop-types';
import breakpoints from '../../theme/breakpoints';

import {
  BasePicture,
  PictureImage,
} from './styles';

// Style variation for tertiary picture is TBD

export const PictureComponent = ({
  id,
  src,
  styles,
  mobileSrc,
  mobileWebpSrc,
  desktopWebpSrc,
  alt,
  variant,
  fullWidth,
  ...rest
}) => {
  const tabletBp = `(max-width: ${breakpoints.values.medium}px)`;

  return (
    <BasePicture
      id={id}
      variant={variant}
      {...rest}>
      {mobileWebpSrc && <source
      srcSet={mobileWebpSrc}
      type="image/webp"
      media={tabletBp}
    />}
      {mobileSrc && <source
      srcSet={mobileSrc}
      media={tabletBp}
    />}
      {desktopWebpSrc && <source
      srcSet={desktopWebpSrc}
      type="image/webp"
    />}
      <PictureImage
        style={styles || {}}
        src={src}
        alt={alt}
        variant={variant}
        fullWidth={fullWidth}/>
    </BasePicture>
  );
};

PictureComponent.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  styles: PropTypes.object,
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  mobileSrc: PropTypes.string,
  mobileWebpSrc: PropTypes.string,
  desktopWebpSrc: PropTypes.string,
  alt: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
};

PictureComponent.defaultProps = { variant: 'primary' };

export default PictureComponent;
